var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "form-control box d-flex" }, [
        _c(
          "ul",
          { staticClass: "ul", staticStyle: { flex: "0 0 0" } },
          [
            _vm._l(_vm.segments, function(seg) {
              return [
                _c("li", { staticClass: "li" }, [
                  _vm._v(_vm._s(seg.suggestion.display))
                ]),
                _vm._v(" "),
                seg.operator
                  ? _c("li", { staticClass: "li" }, [
                      _vm._v(_vm._s(seg.operator.display))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                seg.operator && seg.value
                  ? _c("li", { staticClass: "li" }, [_vm._v(_vm._s(seg.value))])
                  : _vm._e()
              ]
            })
          ],
          2
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.search,
              expression: "search"
            }
          ],
          ref: "txt",
          staticClass: "txt",
          staticStyle: { flex: "1 1 auto" },
          attrs: {
            id: "search_" + _vm._uid,
            type: "text",
            placeholder: _vm.placeholderString
          },
          domProps: { value: _vm.search },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) return
                _vm.search = $event.target.value
              },
              _vm.change
            ],
            keydown: [
              function($event) {
                if (!$event.type.indexOf("key") && $event.keyCode !== 8)
                  return null
                return _vm.onBackspace.apply(null, arguments)
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.onEnter.apply(null, arguments)
              }
            ]
          }
        })
      ]),
      _vm._v(" "),
      _c("text-suggest", {
        ref: "suggest",
        attrs: {
          textBoxId: "search_" + _vm._uid,
          suggestions: _vm.suggestionStrings,
          trigger: "",
          showAlways: true
        },
        on: { insertsuggestion: _vm.onInsertSuggestion }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }